import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChannelType } from '@doddly/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ly-channel-type-icon',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './channel-type-icon.component.html',
  styleUrl: './channel-type-icon.component.scss',
})
export class ChannelTypeIconComponent {
  @Input()
  channelType: ChannelType = 'x';

  @Input() size = '14px';

  get brandDetails(): { icon: string } {
    switch (this.channelType) {
      case 'instagram':
        return { icon: 'instagram' };
      case 'tiktok':
        return { icon: 'tiktok' };
      case 'linkedin':
        return { icon: 'linkedin' };
      case 'facebook':
        return { icon: 'facebook' };
      case 'x':
        return { icon: 'x' };
      case 'threads':
        return { icon: 'threads' };
      case 'bluesky':
        return { icon: 'bluesky' };
      case 'pinterest':
        return { icon: 'pinterest' };
      default:
        return { icon: 'user' };
    }
  }
}
